<template>
  <div class="third-party-account">
    <div class="table-title">已绑账号</div>
    <el-table :data="tableData" style="width: 99.99%">
      <el-table-column type="index" label="序号" width="50" align="center"> </el-table-column>
      <el-table-column prop="flag" label="绑定账号信息" align="center">
        <template slot-scope="scope">
          {{otherAccounts[`${scope.row.flag - 2}`].name}}
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="详情" align="center"> </el-table-column>
      <el-table-column prop="addTime" label="绑定时间" align="center"> </el-table-column>
      <el-table-column prop="status" label="状态" align="center"> </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <a
            href="javascript:void(0)"
            @click="handleDelete(scope.$index, scope.row)"
            >解除绑定</a
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="otherAccount" v-if="tableData.length < 3">
      <p>您还可以绑定以下第三方账号</p>
      <ul>
        <template v-for="(item, index) in otherAccounts">
					<li :key="index" v-if="item.isShow">
						<dl @click="bindAccount(item)">
							<dd><img :src="require(`../../../assets/images/btn_settings_${item.img}.png`)"></dd>
							<dd>{{item.name}}</dd>
						</dl>
					</li>
				</template>
      </ul>
    </div>
  </div>
</template>

<script>
import { getUserInfo, removeThirdpartyAccount } from '@/api/profile';
import { redirectUrl } from '@/setting'
export default {
  name: 'third_party_account',
  data() {
    return {
      tableData: [],
      id: this.$store.state.user.id,
      account: null,
      otherAccounts: [
        {
          name: '微信',
          img: 'wechat',
          isShow: false
        },
        {
          name: 'QQ',
          img: 'qq',
          isShow: false
        },
        {
          name: '微博',
          img: 'sina',
          isShow: false
        }
      ]
    }
  },
  created(){
    this.getUserInfo();
  },

  methods: {
    async getUserInfo(){
      const { data } = await getUserInfo({ id: this.id });
      this.tableData = data.accountList.length>0? data.accountList : [];
      this.account = data.account;
      this.otherAccounts.forEach((item, index) => {
        if(this.tableData.some(subItem => (subItem.flag - 2 == index))) {
          item.isShow = false
        } else {
          item.isShow = true
        }
      })
    },
    handleDelete(index, params) {
      this.$confirm(`<div class="unBindContent"><h3>确定要解绑${this.otherAccounts[params.flag - 2].name}？</h3><div>解绑后将无法使用该第三方账号登录高绩数据</div></div>`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'unBindCancelBtn',
        confirmButtonClass: 'unBindConfirmBtn',
        dangerouslyUseHTMLString: true,
        customClass: 'unBindCustomClass'
      }).then(() => {
        this.removeThirdpartyAccount(params)
      }).catch(() => {   
        console.log('取消');   
      });
      // this.$message.warning('解除账号')
      // 
    },
    removeThirdpartyAccount({account, flag}){
      removeThirdpartyAccount({account, flag}).then(res => {
        this.getUserInfo();
      })
    },
    bindAccount(params) {
      let type = params.img;
      // this.$message.warning('绑定账号')
      let url = null;
      if(type == 'qq') {
        url = `https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101914373&redirect_uri=${redirectUrl}/appLogin&state=qqLogin2${this.account}`
      } else if(type == 'wechat'){
        url = `https://open.weixin.qq.com/connect/qrconnect?appid=wxdf1270941c48d186&scope=snsapi_login&redirect_uri=${redirectUrl}/appLogin&state=weChatLogin2${this.account}&login_type=jssdk&self_redirect=true&styletype=&sizetype=&bgcolor=&rst=&style=black`;
      } else{
        url = `https://api.weibo.com/oauth2/authorize?client_id=2851333222&response_type=code&state=sinaLogin2${this.account}&redirect_uri=${redirectUrl}/appLogin`;
      }
      window.location = url;
    }
  }
}
</script>
<style lang="scss">
.third-party-account {
  text-align: left;
	font-size: 14px;
	.table-title{
		height: 14px;
		margin: 22px 0;
		font-size: 14px;
		font-family: 'Source Han Sans SC';
		font-weight: 400;
		color: #343438;
	}
  .el-table {
    // max-width: 800px;
    th, td{
      height: 45px;
    }
    a {
      color: #514def;
    }
  }
  .otherAccount {
    height: 14px;
    font-size: 14px;
    font-family: 'Source Han Sans SC';
    font-weight: 400;
    color: #343438;
    p {
      margin: 44px 0 40px;
    }
    ul {
			display: flex;
			padding-left: 20px;
      li {
        margin-right: 51px;
        text-align: center;
        dl {
          cursor: pointer;
        }
      }
    }
  }
}
.unBindCustomClass{
  width: 464px;
  height: 200px;
  font-size: 14px;
  padding: 0;
  margin: 0;
  border: none;
  box-shadow: 0px 5px 35px 0px rgba(81, 77, 239, 0.1);
  border-radius: 5px;
  .el-message-box__header{
    padding: 0;
    height: 43px;
    .el-message-box__headerbtn{
      top: 16px;
      right: 19px;
    }
  }
  .el-message-box__btns {
    padding: 0px 20px 23px 30px;
    .unBindCancelBtn{
      width: 60px;
      height: 42px;
      line-height: 42px;
      border: solid thin #A4A4AD;
      border-radius: 4px;
      color: #A4A4AD;
      background-color: #FFFFFF;
      padding: 0;
    }

    .unBindConfirmBtn{
      width: 100px;
      height: 42px;
      line-height: 42px;
      border: none;
      border-radius: 4px;
      color: #fff;
      background-color: #514DEF;
      padding: 0;
    }
  }
  .el-message-box__content{
    padding: 0px 20px 0 30px;
    .unBindContent{
      h3{
        height: 16px;
        line-height: 16px;
        font-size: 16px;
        font-weight: bold;
        color: #343438;
      }
      div{
        color: #343438;
        height: 14px;
        line-height: 14px;
        font-size: 14px;
        margin: 29px 0 33px;
      }
    }
  }
}

</style>
